import cx from 'classnames';
import Container from '@/container';
import {Col, Grid, Row} from '@/grid';
import withBreakpoints from '@/hocs/withBreakpoints';
import {SectionPadding} from '@/section';
import {LetterLine} from '@/svg/index';
import {H2, P} from '@/typography';
import PictureWrapper from '@/ui/images-wrapper';
import {useState} from 'react';
import {Waypoint} from 'react-waypoint';
import Link from '@/links';

import partnerStyles from 'pages/partnership-program/partners.module.scss';

const imgPath = '/static/images/partnership-program/technology-partners/building-api/';

const CirclesImage = withBreakpoints({
  mobile: () => (
    <PictureWrapper
      imgPath={imgPath}
      imageUrl="circles-mobile"
      imageTypeFallback="jpg"
      alt="Building on the Api"
    />
  )
});

const BuildingApi = () => {
  const [active, setActive] = useState(false);

  return (
    <Waypoint
      topOffset="20%"
      bottomOffset="100%"
      onEnter={() => setActive(true)}
      fireOnRapidScroll={false}>
      <div>
        <SectionPadding>
          <Container>
            <Grid fluid>
              <div className={partnerStyles['article-section-wrapper']}>
                <CirclesImage />

                <Row>
                  <Col sm={12} lg={12}>
                    <H2>Building on the API</H2>

                    <P>
                      Workable has dedicated{' '}
                      <span className={partnerStyles['text-highlight-indigo']}>
                        Assessment, Video Interview, Background Check
                      </span>
                      , and{' '}
                      <span className={partnerStyles['text-highlight-indigo']}>OAuth APIs</span>{' '}
                      that are exclusively for partner use.
                    </P>
                    <P>
                      Separately, the Workable API allows you to{' '}
                      <span className={partnerStyles['text-highlight-indigo']}>
                        extract pipeline stages, fetch applicants for a job, update candidate
                        profiles
                      </span>
                      , and much more. Learn more about the full capabilities{' '}
                      <Link
                        href="https://help.workable.com/hc/en-us/articles/115013356548-Workable-API-Documentation"
                        variant="default">
                        here
                      </Link>
                      .
                    </P>
                    <P>
                      Workable customers, and their 3rd party providers, can use the API to get
                      access to this account-level information via their unique Access Token.
                    </P>
                    <P>
                      To get more in-depth information about the API and our documentation,{' '}
                      <Link href="/developers" variant="default">
                        find out more
                      </Link>{' '}
                      in our developers hub.
                    </P>
                  </Col>
                </Row>
                <div className={partnerStyles['article-image']}>
                  <div className={cx(partnerStyles.line, partnerStyles.neonPineapple)}>
                    <LetterLine active={active} />
                  </div>
                  <PictureWrapper
                    imgPath={imgPath}
                    imageUrl="circles"
                    imageTypeFallback="jpg"
                    alt="Building on the Api"
                  />
                </div>
              </div>
            </Grid>
          </Container>
        </SectionPadding>
      </div>
    </Waypoint>
  );
};

export default BuildingApi;
